import React from 'react'
import { Link } from '@material-ui/core'
import { socialIcons } from 'constants/SocialIcons'
import { useStyles } from './styles'

export interface SocialIconProps {
  icon: string
  url: string
  iconColor: string
}

const SocialIcon: React.FC<SocialIconProps> = ({ icon, url, iconColor }) => {
  const classes = useStyles(iconColor)()
  const Icon = socialIcons[icon as keyof typeof socialIcons]

  return (
    <a href={url} target='_blank' rel='noopener noreferrer'>
      <Icon className={classes.icon} />
    </a>
  )
}

export default SocialIcon
